/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusProfileDto } from '../../models/lexplus-profile-dto';

export interface AuthenticationControllerGetProfileV1$Params {
}

export function authenticationControllerGetProfileV1(http: HttpClient, rootUrl: string, params?: AuthenticationControllerGetProfileV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusProfileDto>> {
  const rb = new RequestBuilder(rootUrl, authenticationControllerGetProfileV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusProfileDto>;
    })
  );
}

authenticationControllerGetProfileV1.PATH = '/v1/authentication/profile';
